import { Injectable } from '@angular/core';
import { AtAGlanceNotification } from '@models';

@Injectable({
  providedIn: 'root'
})
export class NotificationFilterService {
  filterBySponsor(
    notifications: AtAGlanceNotification[],
    sponsorSelected: string | null | undefined
  ): AtAGlanceNotification[] {
    if (!Array.isArray(notifications) || notifications.length === 0) {
      return [];
    }

    if (!sponsorSelected || sponsorSelected === 'All') {
      return notifications;
    }

    const normalizedSponsor = this.normalizeValue(sponsorSelected);
    return notifications.filter(
      (notification) => this.normalizeValue(notification.clientName) === normalizedSponsor
    );
  }

  private normalizeValue(value: string | null | undefined): string {
    return (value ?? '').trim().toLowerCase();
  }
}
